import auditStatus from '@/constants/auditStatus'
import { sharedIbPermission } from '@/constants/sharedIbPermission'
import { getIdPass, getPoaPass } from '@/util/register/getAuditPass'

export default {
  // Sub IB permission
  customerDataPermission: state => !state.isSubUser || state.permissionIds.includes(sharedIbPermission.customerData),
  ibDataPermission: state => !state.isSubUser || state.permissionIds.includes(sharedIbPermission.ibData),
  operateAmountPermission: state => !state.isSubUser || state.permissionIds.includes(sharedIbPermission.operateAmount),
  // Onboarding status
  idPass: state => getIdPass(state.poiAuditStatus, state.ibtPoiAuditStatus, state.id3Pass),
  poaPass: state => getPoaPass(state.poaAuditStatus, state.ibtPoaAuditStatus),
  isIbtPoiUnderReview: state =>
    state.ibtPoiAuditStatus === auditStatus.submitted || state.ibtPoiAuditStatus === auditStatus.reaudit,
  isIbtPoaUnderReview: state =>
    state.ibtPoaAuditStatus === auditStatus.submitted || state.ibtPoaAuditStatus === auditStatus.reaudit,
  isIbtPoiEditable: state =>
    state.ibtPoiAuditStatus === auditStatus.init ||
    state.ibtPoiAuditStatus === auditStatus.pending ||
    state.ibtPoiAuditStatus === auditStatus.rejected,
  isIbtPoaEditable: state =>
    state.ibtPoaAuditStatus === auditStatus.init ||
    state.ibtPoaAuditStatus === auditStatus.pending ||
    state.ibtPoaAuditStatus === auditStatus.rejected,
  isIbtPoiResubmit: state =>
    state.ibtPoiAuditStatus === auditStatus.pending || state.ibtPoiAuditStatus === auditStatus.rejected,
  isIbtPoaResubmit: state =>
    state.ibtPoaAuditStatus === auditStatus.pending || state.ibtPoaAuditStatus === auditStatus.rejected,
}
